module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/team",
      "title": "Team"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sub-sections"
    }
  }, [_c('div', {
    staticClass: "sub-section",
    attrs: {
      "id": "team"
    }
  }, [(_vm.teammates.length) ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.teammates), function(teammate, index) {
    return _c('teammate', {
      key: index,
      attrs: {
        "teammate": teammate,
        "github-username": teammate.github_username
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Our team is the all-star team of all-star teams. At least we think so. We value individuality in order to maximize different ways to approach a project. Our team brings a vast array of experience from various fields in order to create the best web, mobile, and game products we can.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f942ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team/Team.vue
// module id = 920
// module chunks = 1